import { MetricRecord } from "@/metrics/runtime"

import type { RunMetricOutput } from "@/types/RunMetricOutput"

export class LLMTextMetricRecord extends MetricRecord {
  unit = "text"
  aggregate_units = "text"

  _renderDeepDive(mo: RunMetricOutput): React.ReactNode {
    return <div>{mo.string_value}</div>
  }
}
